<template>
  <core-FormModal
    v-model="show"
    :submit="submitReport"
    class="mt-3"
    size="lg"
    textSubmit="Solicitar Relatório"
    :scrollable="scrollable"
  >
    <template v-slot:title> Solicitação Relatório </template>
    <template v-slot:body>
      <b-form-row class="d-flex justify-content-center w-100">
        <b-col md="4">
          <b-form-group label="Tipo Arquivo" class="pb-2">
            <input-select
              v-model="model.TipoArquivo"
              :options="TipoArquivoRelatorio"
              single
            />
          </b-form-group>
        </b-col>
        <b-col md="8">
          <label class="switcher md">
            <input
              type="checkbox"
              v-model="model.EnviarEmail"
              class="switcher-input"
            />
            <span class="switcher-indicator">
              <span class="switcher-yes">
                <span class="ion ion-md-checkmark"></span>
              </span>
              <span class="switcher-no">
                <span class="ion ion-md-close"></span>
              </span>
            </span>
            <span class="switcher-label">
              <strong>Permitir notificação via email</strong>
            </span>
          </label>
        </b-col>
      </b-form-row>
    </template>
  </core-FormModal>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      model: { EnviarEmail: false },
      title: "ExportarRelatorio",
    };
  },
  props: {
    submit: Function,
    TipoArquivoRelatorio: Array,
    scrollable: { type: Boolean, default: true }
  },
  methods: {
    openModal() {
      this.show = true;
    },
    close() {
      this.show = false;
      this.model = {};
    },
    submitReport() {
      this.submit(this.model, this.close);
    },
  },
};
</script>

<style>
.md {
  margin-top: 30px;
}
</style>
